import React from 'react'

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useInviteUsersModal } from '@/hooks/useInviteUsersModal'
import InviteUsersForm from '@/pages/manageUsers/components/company/InviteUsersForm'

const InviteUsersModal: React.FC = () => {
  const modal = useInviteUsersModal()

  return (
    <>
      <Dialog
        open={modal.isShowing}
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            modal.hide()
          }
        }}
        aria-label="Invite users"
      >
        <DialogContent size="lg">
          <DialogHeader>
            <DialogTitle>Invite users</DialogTitle>
          </DialogHeader>

          <DialogBody>
            <InviteUsersForm
              onSuccess={modal.hide}
              onCancel={modal.hide}
              autoFocus
            />
          </DialogBody>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default InviteUsersModal
